
import { computed, defineComponent, nextTick, onMounted, onUnmounted, reactive, toRefs, watch } from 'vue'
import ws from '@/websocket/index'

export default defineComponent({
  props: {
    sourceData: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 订阅的码表
    subonType: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 订阅的唯一标识
    listKey: {
      type: String,
      default: 'FOUR_HUNTER_LIST'
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      list: props.sourceData,
      subscribedList: [] as any[],
      currentKeyList: [] as string[]
    })

    pageData.list = computed(() => {
      return props.sourceData
    })

    // 源数据去重
    const removeDuplicateObj = (arr: any) => {
      if (!arr || !arr.length) return []
      const newArr: any = []
      for (const t of arr) {
        if (newArr.find((c: any) => c.symbol === t.symbol && c.market === t.market)) {
          continue
        }
        newArr.push(t)
      }
      return newArr
    }

    // 处理列表订阅消息
    const handleHQLISTMessage = (msg: any) => {
      // 转换为兼容旧格式的 event 对象
      const event = {
        data: JSON.stringify(msg)
      }
      context.emit('message', event)
    }

    // 批量订阅
    function subon(list: any) {
      if (!list || !list.length) return
      const data = removeDuplicateObj(list)

      const stockList: any[] = []
      const keyList: string[] = []

      data.forEach((item: any) => {
        const symbol = item.symbol || item.Inst
        const market = (item.market || item.Exch || '').toLowerCase()

        stockList.push({
          symbol: symbol,
          market: market
        })
        keyList.push(symbol + market)
      })

      console.log('批量订阅股票列表:', stockList.length, '只', keyList)

      // 使用列表订阅
      ws.websocket.safeSubscribeList(props.listKey, stockList)

      pageData.subscribedList = data
      pageData.currentKeyList = keyList
    }

    // 取消批量订阅
    function suboff() {
      if (!pageData.currentKeyList || !pageData.currentKeyList.length) return

      console.log('取消订阅:', props.listKey)
      ws.websocket.safeUnsubscribeList(props.listKey)

      pageData.currentKeyList = []
    }

    // 监听 WebSocket 消息
    onMounted(() => {
      // 监听列表订阅数据
      ws.websocket.on('onHQLIST', handleHQLISTMessage)

      // 监听连接成功事件
      ws.websocket.on('onOpen', () => {
        console.log('WebSocket onOpen, 开始批量订阅...')
        if (props.sourceData && props.sourceData.length) {
          subon(props.sourceData)
        }
      })

      // 如果已经连接，立即订阅
      // if (ws.websocket.state === 3) { // STATE.connected = 3
      console.log('WebSocket 已连接，立即批量订阅', ws)
      console.log('WebSocket props.sourceData', props)
      if (props.sourceData && props.sourceData.length) {
        subon(props.sourceData)
        // }
      }
    })

    // 组件卸载时取消订阅和监听
    onUnmounted(() => {
      suboff()
      ws.websocket.off('onHQLIST', handleHQLISTMessage)
    })

    // 生成订阅列表的唯一标识，用于判断是否需要重新订阅
    const getListSignature = (list: any[]) => {
      if (!list || !list.length) return ''
      return list.map((item: any) => {
        const symbol = item.symbol || item.Inst || ''
        const market = (item.market || item.Exch || '').toLowerCase()
        return `${symbol}_${market}`
      }).sort().join(',')
    }

    // 上一次订阅的签名
    let lastSignature = ''

    // 监听数据变化，只有股票列表变化时才重新订阅
    watch(
      () => props.sourceData,
      (newV: any) => {
        const newSignature = getListSignature(newV)
        // 只有股票列表真正变化时才重新订阅
        if (newSignature !== lastSignature) {
          console.log('sourceData 股票列表变化:', newV?.length, '只')
          lastSignature = newSignature
          // if (ws.websocket.state === 3) { // 已连接
          suboff()
          nextTick(() => {
            subon(newV)
          })
          // }
        }
      },
      { deep: false } // 不使用深度监听，避免数据更新触发重复订阅
    )

    return {
      ...toRefs(pageData)
    }
  }
})
